module.exports = __webpack_public_path__ + "media/images/views/lp/client/client-logo/csi-f73e6151fabf97a1fee1c48424a580a2.png";